(function () {
  const CLOSE_ANIMATION_MS = 300;
  let reopenButtonClosed = false;
  const popup = document.getElementById('promotional-popup');
  const overlay = document.getElementById('promotional-popup-overlay');
  const closeBtn = document.getElementById('promotional-popup-close');
  const reopenBtn = document.getElementById('promotional-popup-reopen');
  const reopenWrapper = document.getElementById('promotional-popup-reopen-wrapper');
  const reopenCloseBtn = document.getElementById('promotional-popup-reopen-close');

  if (!popup) {
    return;
  }

  function showPopup() {
    popup.classList.remove('is-closing');
    popup.style.display = 'block';
    if (overlay) {
      overlay.style.display = 'block';
    }
    if (reopenBtn) {
      reopenBtn.style.display = 'none';
    }
    if (reopenCloseBtn) {
      reopenCloseBtn.style.display = 'none';
    }
    if (reopenWrapper) {
      reopenWrapper.style.display = 'none';
    }
    document.body.classList.add('overflow-hidden');
  }

  function reopenPopup() {
    showPopup();
  }

  function hidePopup() {
    popup.classList.add('is-closing');
    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('is-closing');
    }, CLOSE_ANIMATION_MS);
    if (overlay) {
      overlay.style.display = 'none';
    }
    if (reopenBtn) {
      reopenBtn.style.display = 'block';
    }
    if (reopenCloseBtn) {
      reopenCloseBtn.style.display = 'block';
    }
    if (reopenWrapper && !reopenButtonClosed) {
      reopenWrapper.style.display = 'flex';
    }
    document.body.classList.remove('overflow-hidden');
  }

  function hideReopenButton() {
    if (reopenWrapper) {
      reopenWrapper.style.display = 'none';
      reopenButtonClosed = true;
    }
  }

  function setInitialClosedState() {
    popup.classList.remove('is-closing');
    popup.style.display = 'none';
    if (overlay) {
      overlay.style.display = 'none';
    }
    if (reopenWrapper) {
      reopenWrapper.style.display = 'none';
    }
    if (reopenBtn) {
      reopenBtn.style.display = 'block';
    }
    if (reopenCloseBtn) {
      reopenCloseBtn.style.display = 'block';
    }
    document.body.classList.remove('overflow-hidden');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', hidePopup);
  }

  if (overlay) {
    overlay.addEventListener('click', hidePopup);
  }

  if (reopenBtn) {
    reopenBtn.addEventListener('click', reopenPopup);
  }

  if (reopenCloseBtn) {
    reopenCloseBtn.addEventListener('click', hideReopenButton);
  }

  setInitialClosedState();

  if (!reopenButtonClosed && reopenWrapper) {
    reopenWrapper.style.display = 'flex';
  }

  window.addEventListener('resize', function () {
    if (!reopenButtonClosed && reopenWrapper) {
      reopenWrapper.style.display = 'flex';
    }
  });
})();
